export interface Category {
  key: string;
  url: string;
  icon: string;
  image: string;
  imageAlt: string;
}

export const categories: Category[] = [
  {
    key: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20clean%20white%20and%20sage%20green%20sneakers%20placed%20on%20a%20soft%20warm%20cream%20studio%20surface%20with%20gentle%20natural%20daylight%20minimalist%20editorial%20product%20photography%20subtle%20soft%20shadows%20calm%20fresh%20aesthetic%20warm%20amber%20accents%20high%20detail%20simple%20clean%20composition&width=600&height=450&seq=cat-shoes&orientation=landscape',
    imageAlt: 'Clean white and sage green sneakers on a cream studio background',
  },
  {
    key: 'hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20stack%20of%20soft%20pastel%20hoodies%20and%20sweatshirts%20in%20sage%20cream%20and%20warm%20beige%20tones%20arranged%20on%20a%20bright%20minimal%20studio%20table%20with%20gentle%20daylight%20editorial%20product%20photography%20subtle%20diffused%20shadows%20airy%20clean%20aesthetic%20high%20detail&width=600&height=450&seq=cat-hoodies&orientation=landscape',
    imageAlt: 'Folded pastel hoodies and sweatshirts on a bright studio table',
  },
  {
    key: 'tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20crisp%20folded%20cotton%20t-shirts%20in%20soft%20cream%20sage%20and%20warm%20sand%20colors%20neatly%20stacked%20on%20a%20light%20minimal%20surface%20with%20natural%20daylight%20editorial%20apparel%20photography%20gentle%20soft%20shadows%20fresh%20clean%20aesthetic%20high%20detail%20simple%20composition&width=600&height=450&seq=cat-tshirts&orientation=landscape',
    imageAlt: 'Folded cotton t-shirts in soft neutral colors',
  },
  {
    key: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-haze-line',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20lightweight%20jacket%20in%20warm%20beige%20and%20olive%20tones%20displayed%20on%20a%20minimal%20wooden%20hanger%20against%20a%20clean%20cream%20wall%20with%20soft%20natural%20daylight%20editorial%20product%20photography%20subtle%20shadows%20fresh%20modern%20aesthetic%20high%20detail&width=600&height=450&seq=cat-jackets&orientation=landscape',
    imageAlt: 'Lightweight beige and olive jacket on a wooden hanger',
  },
  {
    key: 'pants',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    image: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20neatly%20folded%20casual%20pants%20and%20shorts%20in%20soft%20sage%20cream%20and%20sand%20tones%20arranged%20on%20a%20bright%20minimal%20studio%20surface%20with%20gentle%20natural%20light%20editorial%20apparel%20photography%20subtle%20diffused%20shadows%20clean%20fresh%20aesthetic%20high%20detail&width=600&height=450&seq=cat-pants&orientation=landscape',
    imageAlt: 'Folded casual pants and shorts in soft neutral tones',
  },
  {
    key: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-capsule-line',
    image: 'https://readdy.ai/api/search-image?query=A%20selection%20of%20minimal%20baseball%20caps%20and%20beanies%20in%20cream%20sage%20and%20warm%20amber%20colors%20arranged%20on%20a%20clean%20light%20studio%20surface%20with%20soft%20natural%20daylight%20editorial%20product%20photography%20subtle%20soft%20shadows%20fresh%20modern%20aesthetic%20high%20detail&width=600&height=450&seq=cat-headwear&orientation=landscape',
    imageAlt: 'Minimal baseball caps and beanies in neutral colors',
  },
  {
    key: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=A%20matching%20two-piece%20casual%20outfit%20set%20in%20soft%20sage%20green%20and%20cream%20displayed%20flat%20lay%20on%20a%20minimal%20studio%20background%20with%20gentle%20natural%20daylight%20editorial%20product%20photography%20subtle%20shadows%20clean%20fresh%20aesthetic%20high%20detail&width=600&height=450&seq=cat-sets&orientation=landscape',
    imageAlt: 'Matching two-piece casual outfit set flat lay',
  },
  {
    key: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-leaf-line',
    image: 'https://readdy.ai/api/search-image?query=A%20set%20of%20soft%20minimal%20underwear%20and%20basics%20in%20cream%20sage%20and%20light%20gray%20tones%20neatly%20arranged%20on%20a%20bright%20clean%20studio%20surface%20with%20gentle%20natural%20daylight%20editorial%20product%20photography%20subtle%20soft%20shadows%20fresh%20clean%20aesthetic%20high%20detail&width=600&height=450&seq=cat-underwear&orientation=landscape',
    imageAlt: 'Soft minimal underwear and basics in neutral tones',
  },
  {
    key: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-basketball-line',
    image: 'https://readdy.ai/api/search-image?query=A%20vintage-inspired%20sports%20jersey%20in%20cream%20and%20sage%20green%20with%20subtle%20retro%20detailing%20displayed%20on%20a%20minimal%20studio%20surface%20with%20soft%20natural%20daylight%20editorial%20product%20photography%20subtle%20shadows%20clean%20fresh%20aesthetic%20high%20detail&width=600&height=450&seq=cat-jersey&orientation=landscape',
    imageAlt: 'Vintage-inspired cream and sage sports jersey',
  },
  {
    key: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-vip-diamond-line',
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20minimal%20accessories%20including%20a%20watch%20sunglasses%20and%20small%20jewelry%20pieces%20in%20warm%20amber%20and%20silver%20tones%20arranged%20on%20a%20clean%20cream%20studio%20surface%20with%20gentle%20daylight%20editorial%20product%20photography%20subtle%20shadows%20high%20detail&width=600&height=450&seq=cat-accessories&orientation=landscape',
    imageAlt: 'Minimal accessories including a watch and sunglasses',
  },
  {
    key: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    image: 'https://readdy.ai/api/search-image?query=A%20minimal%20canvas%20tote%20bag%20and%20a%20small%20crossbody%20bag%20in%20sage%20green%20and%20warm%20beige%20tones%20displayed%20on%20a%20clean%20light%20studio%20surface%20with%20soft%20natural%20daylight%20editorial%20product%20photography%20subtle%20soft%20shadows%20fresh%20modern%20aesthetic%20high%20detail&width=600&height=450&seq=cat-bags&orientation=landscape',
    imageAlt: 'Minimal canvas tote and crossbody bags in neutral tones',
  },
  {
    key: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-links-line',
    image: 'https://readdy.ai/api/search-image?query=A%20few%20minimal%20leather%20belts%20in%20warm%20brown%20tan%20and%20cream%20tones%20elegantly%20coiled%20on%20a%20clean%20bright%20studio%20surface%20with%20gentle%20natural%20daylight%20editorial%20product%20photography%20subtle%20soft%20shadows%20fresh%20clean%20aesthetic%20high%20detail&width=600&height=450&seq=cat-belts&orientation=landscape',
    imageAlt: 'Minimal leather belts in warm brown and tan tones',
  },
  {
    key: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=A%20small%20glass%20perfume%20bottle%20with%20a%20minimal%20label%20in%20soft%20amber%20and%20cream%20tones%20placed%20on%20a%20clean%20bright%20studio%20surface%20with%20gentle%20natural%20daylight%20editorial%20product%20photography%20subtle%20soft%20shadows%20fresh%20clean%20aesthetic%20high%20detail&width=600&height=450&seq=cat-perfumes&orientation=landscape',
    imageAlt: 'Minimal glass perfume bottle in amber and cream tones',
  },
  {
    key: 'other',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-gift-line',
    image: 'https://readdy.ai/api/search-image?query=A%20varied%20collection%20of%20small%20lifestyle%20items%20and%20gadgets%20including%20a%20notebook%20keychain%20and%20bottle%20in%20soft%20neutral%20tones%20arranged%20on%20a%20clean%20cream%20studio%20surface%20with%20gentle%20daylight%20editorial%20product%20photography%20subtle%20shadows%20high%20detail&width=600&height=450&seq=cat-other&orientation=landscape',
    imageAlt: 'Varied lifestyle items and gadgets in neutral tones',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';